var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSatellites(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.964 8.411a.204.204 0 01-.208.202h-.41c-.111 0-.2-.086-.204-.194-.105-3.768-3.266-6.813-7.186-6.906-.113-.003-.203-.087-.203-.195V.926c0-.111.095-.202.21-.2 4.362.106 7.89 3.496 8 7.685zm-2.613.006a.198.198 0 01-.202.196h-.395a.198.198 0 01-.2-.187c-.09-2.397-2.108-4.323-4.606-4.42-.107-.004-.195-.088-.195-.191V3.43c0-.108.093-.199.205-.194 2.926.103 5.288 2.37 5.393 5.18zm-4.526 4.857c.967 0 1.934-.225 2.807-.677.265-.137.3-.49.09-.695L6.311 8.63l.905-.87.04.01a.58.58 0 00.159.03c.45 0 .814-.35.814-.783 0-.433-.364-.782-.814-.782-.45 0-.815.35-.815.782 0 .055.015.103.03.152l.011.039-.906.87L2.326 4.8a.482.482 0 00-.333-.132.433.433 0 00-.387.218C.4 7.043.743 9.788 2.636 11.607a6.032 6.032 0 004.19 1.667z",
    fill: "silver"
  })));
}
SvgSatellites.displayName = 'Satellites';
export default SvgSatellites;